import React from 'react'

export interface ItemProps {
  title: React.ReactNode
  children: React.ReactNode
  isDisabled?: boolean
  isHidden?: boolean
}

export const Item: React.FC<ItemProps> = ({ children }) => {
  return <>{children}</>
}

Item.displayName = 'Item'
